<template>
  <div class="quick-v-tocart">
    <button class="adv-add-to-cart-button-base" :disabled="disabled" @click="addToCart">
      <span>{{ buttonText }}</span>
    </button>
  </div>
</template>

<script>

export default {
  name: 'AdvCardAddToCartButtonBase',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    buttonText: {
      type: String,
      required: true
    }
  },
  methods: {
    addToCart () {
      this.$emit('add-to-cart')
    }
  }
}
</script>

<style lang="scss" scoped>
.quick-v-tocart {
  flex: 1
}
.adv-add-to-cart-button-base {
  background-color: #1A1818;
  border: 0;
  color: #fff;
  width: 100%;
  display: block;
  text-align: center;
  padding-bottom: 10px;
  padding-top: 10px;
  transition: all 0.1s ease-in-out;
  font-size: 1.063rem;
  font-weight: 500;
  height: 58px;
  @media screen and (max-width: 768px) {
    height: 43px;
    font-size: 0.875rem;
  }
  &:hover {
    background-color: #C7A34D;
  }
  &:disabled {
    background-color: #CBCBCB;
    color: black;
  }
}
</style>
